import { useEffect } from "react";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
// components
import { useDashboardLayoutContext } from "./DashbordLayout";
import RoleBaseGuard from "./RoleBaseGuard";
// utils
import { cancelAllWork } from "../../components/common/customAxios";
// actions
import { setPageName, setLayout } from "../../actions/layout";

const DashboardComponent = connect()(
  ({ dispatch, page, component: Component, routeProp, ...prop }) => {
    /* ---------------------------------- Hooks --------------------------------- */
    const { setLoading } = useDashboardLayoutContext();

    useEffect(() => {
      dispatch(setPageName(page));

      return () => {
        cancelAllWork();
        dispatch(setLayout({ isLoading: false, isHide: true }));
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <RoleBaseGuard page={page}>
        <Component {...prop} {...routeProp} setLoading={setLoading} />
      </RoleBaseGuard>
    );
  }
);

export default function DashboardRoute({ page, component, ...prop }) {
  return (
    <Route
      render={(routeProp) => (
        <DashboardComponent
          key={page}
          component={component}
          page={page}
          routeProp={routeProp}
        />
      )}
      {...prop}
    />
  );
}
